import React from 'react'
import {translate} from 'react-i18next'

import FooterLinksView from './FooterLinksView'
import CopyrightWrapper from './CopyrightWrapper'
import CopyrightView from './CopyrightView'
import YearView from './YearView'
import {ELEMENTS_IDS} from 'const'
import {GoogleAnalyticsService} from 'services'
import CookieBannerLink from './CookieBannerLink'
import {getAgbLink, getDsbLink, getImpressumLink, getSupportLink} from 'utils/languageUtils'
import {TopCopyrightSeparator} from '../FooterSeparator'

const ids = ELEMENTS_IDS.footer

const Copyright = ({t, handleLink}) => (
  <CopyrightWrapper>
    <TopCopyrightSeparator />
    <CopyrightView>
      <FooterLinksView>
        <a
          target="_blank"
          rel="noreferrer"
          id={ids.impressum}
          href={getImpressumLink()}
          onClick={e => GoogleAnalyticsService.trackGeneralNavigation('footer', 'impressum') && handleLink(e)}>
          {t('copyright.policy.legal-info')}
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          id={ids.dsb}
          href={getDsbLink()}
          onClick={e => GoogleAnalyticsService.trackGeneralNavigation('footer', 'privacy-policy') && handleLink(e)}>
          {t('copyright.policy.pp')}
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          id={ids.agb}
          href={getAgbLink()}
          onClick={e => GoogleAnalyticsService.trackGeneralNavigation('footer', 'terms-of-service') && handleLink(e)}>
          {t('copyright.policy.tos')}
        </a>
        <CookieBannerLink
          id={ids.cookieSettings}
          trackClick={() => GoogleAnalyticsService.trackGeneralNavigation('footer', 'cookie-settings')}>
          {t('copyright.policy.cookie-settings')}
        </CookieBannerLink>
        <a
          target="_blank"
          rel="noreferrer"
          id={ids.support}
          href={getSupportLink()}
          onClick={e => GoogleAnalyticsService.trackGeneralNavigation('footer', 'support') && handleLink(e)}>
          {t('copyright.policy.support')}
        </a>
      </FooterLinksView>
      <hr />
      <YearView>© {t('copyright.copyright')}</YearView>
    </CopyrightView>
  </CopyrightWrapper>
)

export {Copyright as PureCopyright}

export default translate()(Copyright)
